import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { IAppConfig } from '../_models/appconfig.interface';
import * as moment from 'moment';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;

  constructor(private http: HttpClient) { }

  load() {
    return new Promise<void>((resolve, reject) => {
      this.getConfig().toPromise().then((data: IAppConfig) => {
        AppConfig.settings = data;
        resolve();
      }).catch((response: any) => {
        reject('Could not load file');
      });
    });


  }//end load

  getConfig() {
    const jsonFile = 'assets/config/config.dev.json?v='+ moment(new Date()).format('YYYYMMDDHHmm');
    return this.http.get<IAppConfig>(jsonFile);
  }//end


}//end 